module.exports = __webpack_public_path__ + "img/office.7975ba8d.png";